"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getQuantityPickerUtilityClass = getQuantityPickerUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getQuantityPickerUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('OriMuiQuantityPicker', slot);
}
const quantityPickerClasses = (0, _base.generateUtilityClasses)('OriMuiQuantityPicker', ['root', 'input', 'focused', 'disabled', 'readOnly', 'iconButton', 'increaseButton', 'decreaseButton', 'containedLarge', 'containedMedium', 'textLarge', 'textMedium', 'sizeLarge', 'sizeMedium']);
var _default = exports.default = quantityPickerClasses;
